


export const pixels_per_inch = 92; //Graph only works on a certain kind of monitor.
export const grid_size = 46;
export const grid_count = 0;
export const start_p = 0;

//calculated
export const map_size = 800

export const mid_x = map_size / 2;
export const mid_y = map_size / 2;

export const player_x = map_size / 2;
export const player_y = map_size - 100;

export const pixels_to_km = pixels_per_inch / 2.5


// export const pixels_to_km = 50.3;